module.exports = __webpack_public_path__ + "img/view3d-notice-dhfx2.32697c2c.png";